import {
	GET_SNMP_LIST,
	GET_SNMP_LIST_FAIL,
	GET_SNMP_LIST_SUCCESS,
} from '../../constants/globalProfileConstants/snmpConstants';

/**
 * Reducer function for managing SNMP list state.
 *
 * This reducer handles actions related to fetching SNMP data.
 * It updates the state based on the dispatched action type and payload.
 *
 * @param {object} state - Current state of the SNMP list.
 * @param {object} action - Action object that contains information about the action type and payload.
 * @return {object} - New state after applying the action.
 */
export const snmpListReducer = (state = { snmpList: {} }, action) => {
	switch (action.type) {
		case GET_SNMP_LIST:
			return {
				loading: true,
			};
		case GET_SNMP_LIST_SUCCESS:
			return {
				loading: false,
				snmpList: action.payload,
			};
		case GET_SNMP_LIST_FAIL:
			return {
				loading: false,
				error: action.payload,
			};
		default:
			return state;
	}
};
